import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";
const DEFAULT_SECONDARY_COLOR = "var(--label-tertiary)";

const ROTATE_VALUE_TOP_LEFT = 0;
const ROTATE_VALUE_TOP_RIGHT = 90;
const ROTATE_VALUE_BOTTOM_RIGHT = 180;
const ROTATE_VALUE_BOTTOM_LEFT = 270;

enum RadiusSide {
    TopLeft = "topLeft",
    TopRight = "topRight",
    BottomRight = "bottomRight",
    BottomLeft = "bottomLeft"
}

interface Props extends IconProps {
    side?: RadiusSide;
}

function calculateRotationByPosition(side: RadiusSide): number {
    switch (side) {
        case RadiusSide.TopLeft:
            return ROTATE_VALUE_TOP_LEFT;
        case RadiusSide.TopRight:
            return ROTATE_VALUE_TOP_RIGHT;
        case RadiusSide.BottomRight:
            return ROTATE_VALUE_BOTTOM_RIGHT;
        case RadiusSide.BottomLeft:
            return ROTATE_VALUE_BOTTOM_LEFT;
        // no default
    }
}

function IconRadiusAlignment({
    class: cssClass,
    color,
    secondaryColor,
    side = RadiusSide.TopLeft
}: Props) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;
    const secondaryFill = secondaryColor ?? `var(--icon-secondary-color, ${DEFAULT_SECONDARY_COLOR})`;
    const rotation = calculateRotationByPosition(side);

    return (
        <svg class={cssClass} width="12" height="12" viewBox="0 0 12 12" fill="none" style={{ transform: `rotate(${rotation}deg)` }} xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="M1 2v2H0V2a2 2 0 0 1 2-2h2v1H2a1 1 0 0 0-1 1z"/>
            <path fill={secondaryFill} d="M11 2v2h1V2a2 2 0 0 0-2-2H8v1h2a1 1 0 0 1 1 1zM1 10V8H0v2a2 2 0 0 0 2 2h2v-1H2a1 1 0 0 1-1-1zM11 10V8h1v2a2 2 0 0 1-2 2H8v-1h2a1 1 0 0 0 1-1z"/>
        </svg>
    );
}

export default IconRadiusAlignment;
export { RadiusSide };
